import { UseFormReturn } from 'react-hook-form'
import CtaEditor from '@/components/shared/CtaEditor'

interface LinkRowEditorProps {
  form: UseFormReturn<any>
  /** Dot path to the link row, e.g. `columns.0.links.1` or `items.2.links.0`. */
  basePath: string
  languageId: number
}

/**
 * Shared editor for one `LinkRowFormValues` row (see `@/lib/linkRow`) — a
 * label plus a link target, no fields of its own beyond what `CtaEditor`
 * already renders. Used by both Footer column links (`FooterColumnEditor`)
 * and Navigation dropdown-item links (`NavigationItemEditor`).
 */
export function LinkRowEditor({ form, basePath, languageId }: LinkRowEditorProps) {
  return (
    // CtaEditor's own "CTA Label" field IS this row's (required) label —
    // bound to `profiles.${languageId}.label`, so there's no separate
    // duplicate label input.
    <CtaEditor
      control={form.control}
      languageId={languageId}
      labelName={`${basePath}.profiles.${languageId}.label`}
      linkName={`${basePath}.external_url`}
      newTabName={`${basePath}.link_new_tab`}
      linkPageIdName={`${basePath}.link_page_id`}
      linkTypeName={`${basePath}.link_type`}
      linkCategoryIdName={`${basePath}.link_category_id`}
      linkCollectionIdName={`${basePath}.link_collection_id`}
    />
  )
}
